export default function (Site, $) {
	Site.widget('no-hero', {
		_create () {
			this.noHero()
		},

		noHero() {
			$('body').addClass('no-hero');
		}
	})
}